/**
 * Scoring de backends de storage para seleção dinâmica.
 */

import type { StorageHealth } from './IQueueStorage';

export interface StorageScoreInput {
  name: string;
  health: StorageHealth;
  latencyMs: number;
  corruptionDetected: boolean;
  quotaPressure: number;
}

export function scoreStorageBackend(input: StorageScoreInput): number {
  let score = 100;
  if (!input.health.ok) score -= 50;
  score -= Math.min(input.latencyMs / 20, 35);
  if (input.corruptionDetected) score -= 40;
  score -= Math.min(input.quotaPressure * 30, 25);
  if (input.name === 'indexeddb') score += 5;
  return Math.max(0, score);
}

export function pickBestScoredBackend<T extends { score: number }>(
  candidates: T[]
): T | null {
  if (candidates.length === 0) return null;
  return candidates.reduce((best, cur) => (cur.score > best.score ? cur : best));
}
